/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sales': {
    width: 173,
    height: 173,
    viewBox: '0 0 173 173',
    data: '<path pid="0" d="M173 79.292h-14.78a72.212 72.212 0 00-64.51-64.509V0H79.29v14.783a72.212 72.212 0 00-64.51 64.509H0v14.416h14.78a72.209 72.209 0 0064.51 64.509V173h14.42v-14.783a72.209 72.209 0 0064.51-64.509H173V79.292zm-79.29 64.382v-6.716H79.29v6.716a57.729 57.729 0 01-49.96-49.966h6.71V79.292h-6.71a57.726 57.726 0 0149.96-49.959v6.709h14.42v-6.709a57.726 57.726 0 0149.96 49.959h-6.71v14.416h6.71a57.729 57.729 0 01-49.96 49.966zm0-93.216H79.29v7.575a18.02 18.02 0 003.61 35.675h7.2a3.604 3.604 0 110 7.209H64.88v14.416h14.41v7.209h14.42v-7.575a18.019 18.019 0 00-3.61-35.675h-7.2a3.604 3.604 0 110-7.209h25.23V57.667H93.71v-7.209z" fill-rule="evenodd"/>'
  }
})
